import type { ComparisonConfig } from './ComparisonPage';


const INNROAD_TH: ComparisonConfig = {
  slug: 'hotelstack-vs-innroad',
  competitorName: 'innRoad',
  heroTitle: 'HotelStack.io เทียบกับ innRoad',
  heroSubtitle: 'innRoad เป็น PMS คลาวด์จากสหรัฐฯ สำหรับโรงแรมอิสระพร้อมฟีเจอร์พื้นฐาน HotelStack.io มอบ 36 โมดูลรวมจัดการรายได้ขั้นสูง อาหารและเครื่องดื่ม/POS รองรับหลายสาขา และปฏิบัติตามกฎหมายทั่วโลก — ในราคาที่เทียบเคียงได้',
  overviewComparison: [
    { label: 'โมดูลทั้งหมด', hotelstack: '36 โมดูลแบบบูรณาการ', competitor: 'กว่า 8 ฟีเจอร์หลัก' },
    { label: 'ราคา', hotelstack: 'เริ่มต้น $49/เดือน', competitor: 'เริ่มต้น $100+/เดือน' },
    { label: 'หลายสาขา', hotelstack: 'จัดการเครือข่ายเต็มรูปแบบ', competitor: 'ไม่รองรับ' },
    { label: 'อาหารและเครื่องดื่ม / POS', hotelstack: 'ในตัว', competitor: 'ไม่มี' },
    { label: 'การเข้าถึงทั่วโลก', hotelstack: 'กว่า 40 ประเทศ', competitor: 'เน้นสหรัฐฯ' },
    { label: 'การจัดการรายได้', hotelstack: 'ขั้นสูง (ในตัว)', competitor: 'เครื่องมือราคาพื้นฐาน' },
  ],
  featureTable: [
    {
      category: 'ระบบจัดการโรงแรมหลัก',
      features: [
        { name: 'PMS บนคลาวด์', hotelstack: true, competitor: true },
        { name: 'บอร์ดห้องพักแบบภาพ', hotelstack: true, competitor: true },
        { name: 'การจัดการการจอง', hotelstack: true, competitor: true },
        { name: 'วิซาร์ดตรวจสอบกลางคืน', hotelstack: true, competitor: true },
        { name: 'การจัดการโฟลิโอแขก', hotelstack: true, competitor: true },
        { name: 'พอร์ทัลเช็คอินออนไลน์', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'การจัดจำหน่ายและการจอง',
      features: [
        { name: 'ตัวจัดการช่องทาง (กว่า 100 OTA)', hotelstack: true, competitor: 'OTA จำกัด' },
        { name: 'การเชื่อมต่อ GDS', hotelstack: true, competitor: true },
        { name: 'ระบบจองไม่มีค่าคอมมิชชั่น', hotelstack: true, competitor: true },
        { name: 'การจองแบบกลุ่ม', hotelstack: true, competitor: 'พื้นฐาน' },
        { name: 'จัดการราคาองค์กร', hotelstack: true, competitor: 'จำกัด' },
      ],
    },
    {
      category: 'การจัดการรายได้',
      features: [
        { name: 'กฎการกำหนดราคาไดนามิก', hotelstack: true, competitor: 'พื้นฐาน' },
        { name: 'ตัวจำลองรายได้ What-If', hotelstack: true, competitor: false },
        { name: 'ตัวตรวจสอบราคาคู่แข่ง', hotelstack: true, competitor: false },
        { name: 'การพยากรณ์อุปสงค์', hotelstack: true, competitor: false },
        { name: 'การวิเคราะห์ RevPAR', hotelstack: true, competitor: 'พื้นฐาน' },
      ],
    },
    {
      category: 'การดำเนินงานและอาหารและเครื่องดื่ม',
      features: [
        { name: 'เทอร์มินัล POS', hotelstack: true, competitor: false },
        { name: 'โมดูลบริการห้องพัก', hotelstack: true, competitor: false },
        { name: 'การจัดการแม่บ้าน', hotelstack: true, competitor: 'พื้นฐาน' },
        { name: 'ใบสั่งงานซ่อมบำรุง', hotelstack: true, competitor: false },
        { name: 'การจัดตารางพนักงาน', hotelstack: true, competitor: false },
        { name: 'ระบบแสดงผลครัว', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'รายงานและการปฏิบัติตามกฎหมาย',
      features: [
        { name: 'รายงานด่วน', hotelstack: true, competitor: true },
        { name: 'งบกำไรขาดทุน', hotelstack: true, competitor: false },
        { name: 'รายงานอัตราการจอง', hotelstack: true, competitor: false },
        { name: 'การออกบิลหลายสกุลเงิน', hotelstack: true, competitor: false },
        { name: 'การปฏิบัติตามกฎหมายภาษีท้องถิ่น', hotelstack: true, competitor: 'สหรัฐฯ เท่านั้น' },
        { name: 'ตัวสร้างรายงานแบบกำหนดเอง', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'ความยืดหยุ่นและออฟไลน์',
      features: [
        { name: 'PWA ที่ใช้งานออฟไลน์ได้', hotelstack: true, competitor: false },
        { name: 'คิวการเปลี่ยนแปลงแบบออฟไลน์', hotelstack: true, competitor: false },
        { name: 'ซิงค์เบื้องหลังเมื่อเชื่อมต่อใหม่', hotelstack: true, competitor: false },
        { name: 'การกระทบยอดที่ตรวจจับความขัดแย้ง', hotelstack: true, competitor: false },
        { name: 'ฟรอนต์เดสก์ที่ติดตั้งได้', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'ฝ่ายขายองค์กรและกรุ๊ป',
      features: [
        { name: 'การจัดการราคาองค์กร', hotelstack: true, competitor: 'จำกัด' },
        { name: 'การจองแบบกรุ๊ปพร้อมรายชื่อห้องพัก', hotelstack: true, competitor: 'พื้นฐาน' },
        { name: 'รายงานอายุลูกหนี้และผลผลิต', hotelstack: true, competitor: false },
        { name: 'การจองร้านอาหาร', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'พนักงานและทรัพยากรบุคคล',
      features: [
        { name: 'ทำเนียบพนักงานและการจัดตารางเวร', hotelstack: true, competitor: false },
        { name: 'การประมวลผลเงินเดือน', hotelstack: true, competitor: false },
        { name: 'การลาและการลงเวลา', hotelstack: true, competitor: false },
        { name: 'การวิเคราะห์ผลการปฏิบัติงาน', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$100+',
    hotelstackNote: 'รวมทั้ง 36 โมดูล รองรับหลายสกุลเงินทั่วโลก ราคาตามภูมิภาคเป็น EUR, GBP, AED, INR, THB เริ่มต้นใช้งานและย้ายข้อมูลฟรี',
    competitorNote: 'ราคาแบบเสนอราคาจาก $100+/เดือน เน้นสหรัฐฯ มีฟีเจอร์ระหว่างประเทศจำกัด ฟีเจอร์พื้นฐานไม่มีอาหารและเครื่องดื่ม ไม่มีหลายสาขา ไม่มีการวิเคราะห์ขั้นสูง',
  },
  advantages: [
    'โมดูลมากกว่าสี่เท่า (36 เทียบกับ 8+) ในราคาเริ่มต้นประมาณครึ่งหนึ่ง',
    'จัดการเครือโรงแรมหลายสาขาเต็มรูปแบบ — innRoad รองรับแค่สาขาเดียว',
    'โมดูลอาหารและเครื่องดื่มสมบูรณ์พร้อม POS บริการห้องพัก แสดงผลครัว และจัดการเมนู',
    'จัดการรายได้ขั้นสูงพร้อมราคาไดนามิก การพยากรณ์ และตัวจำลอง',
    'เข้าถึงทั่วโลกกว่า 40 ประเทศ เทียบกับ innRoad ที่เน้นแค่สหรัฐฯ',
    'การออกบิลหลายสกุลเงินและปฏิบัติตามกฎหมายภาษีท้องถิ่นสำหรับสถานที่ระหว่างประเทศ',
    'โปรแกรมสะสมคะแนน CRM แขก และสื่อสารอัตโนมัติรวมอยู่',
    'เริ่มต้นใช้งานฟรีและย้ายข้อมูลพร้อมสนับสนุนเฉพาะ 24/7',
  ],
  verdict: {
    title: 'คำตัดสินของเรา',
    summary: 'innRoad เป็น PMS คลาวด์ตรงไปตรงมาสำหรับโรงแรมอิสระในสหรัฐฯ ที่ต้องการจัดการการจองและฟร้อนท์เดสก์พื้นฐาน HotelStack.io มอบแพลตฟอร์มที่ครอบคลุมกว่าอย่างมากพร้อมสี่เท่าของโมดูล รองรับหลายสาขา อาหารและเครื่องดื่ม/POS เครื่องมือรายได้ขั้นสูง และเข้าถึงทั่วโลก — ทั้งหมดในราคาที่ต่ำกว่า สำหรับโรงแรมที่วางแผนเติบโตเกินกว่า PMS พื้นฐาน HotelStack.io เป็นทางเลือกที่ชัดเจน',
    bestFor: [
      'โรงแรมอิสระที่ต้องการอัปเกรดจาก PMS พื้นฐานสู่แพลตฟอร์มครบวงจร',
      'สถานที่ที่ต้องการอาหารและเครื่องดื่ม POS และเครื่องมือดำเนินงานที่ innRoad ไม่มี',
      'โรงแรมที่ขยายสู่ต่างประเทศต้องการเครื่องมือหลายสกุลเงินและปฏิบัติตามกฎหมาย',
      'สถานที่ที่ต้องการจัดการหลายสาขาสำหรับการเติบโตในอนาคต',
      'โรงแรมที่ต้องการจัดการรายได้ขั้นสูงเกินกว่าตั้งราคาพื้นฐาน',
    ],
  },
  faqItems: [
    { question: 'ฉันสามารถย้ายจาก innRoad มาที่ HotelStack.io ได้หรือไม่?', answer: 'ได้ ทีมย้ายข้อมูลของเราดำเนินการถ่ายโอนข้อมูลทั้งหมดจาก innRoad รวมถึงโปรไฟล์แขก ประวัติการจอง แผนราคา และการตั้งค่าห้อง การย้ายข้อมูลฟรีและมักจะเสร็จภายใน 48 ชั่วโมงโดยไม่หยุดชะงัก' },
    { question: 'HotelStack.io รองรับโรงแรมอิสระในสหรัฐฯ เหมือน innRoad หรือไม่?', answer: 'แน่นอน HotelStack.io รองรับโรงแรมอิสระในสหรัฐฯ และกว่า 40 ประเทศอื่น โรงแรมในสหรัฐฯ ได้ทั้ง 36 โมดูลรวมฟีเจอร์ที่ innRoad ไม่มีเช่น อาหารและเครื่องดื่ม/POS จัดการรายได้ และรองรับหลายสาขา — เริ่มต้นที่ $49/เดือน' },
    { question: 'HotelStack.io เปรียบเทียบกับ innRoad ในด้านการเชื่อมต่อ GDS อย่างไร?', answer: 'ทั้งสองแพลตฟอร์มมีการเชื่อมต่อ GDS ผ่าน Amadeus และ Sabre HotelStack.io ยังเชื่อมต่อกับกว่า 100 OTA ทั่วโลก มี Metasearch Integration และรวมระบบจองไม่มีค่าคอมมิชชั่น (BookMyRoom.io) — ทั้งหมดรวมอยู่ในราคาพื้นฐาน' },
    { question: 'HotelStack.io จัดการหลายสาขาได้ต่างจาก innRoad หรือไม่?', answer: 'ใช่ HotelStack.io รวมจัดการเครือข่ายเต็มรูปแบบพร้อมแดชบอร์ดส่วนกลาง การวิเคราะห์ข้ามสาขา จัดจำหน่ายราคาร่วม บังคับมาตรฐานแบรนด์ และรายงานรวม innRoad ออกแบบมาสำหรับดำเนินงานสาขาเดียวเท่านั้น' },
  ],
};

const WEBREZPRO_TH: ComparisonConfig = {
  slug: 'hotelstack-vs-webrezpro',
  competitorName: 'WebRezPro',
  heroTitle: 'HotelStack.io เทียบกับ WebRezPro',
  heroSubtitle: 'WebRezPro เป็น PMS คลาวด์จากแคนาดาที่เน้นด้านบัญชีสำหรับโรงแรมขนาดเล็กถึงกลาง HotelStack.io มอบแพลตฟอร์มทันสมัยที่มีฟีเจอร์ครบครันพร้อม 36 โมดูล UI ระดับองค์กร เครื่องมือรายได้ขั้นสูง และอาหารและเครื่องดื่ม/POS เต็มรูปแบบ — ออกแบบมาสำหรับยุคใหม่ของการบริการ',
  overviewComparison: [
    { label: 'โมดูลทั้งหมด', hotelstack: '36 โมดูลแบบบูรณาการ', competitor: 'กว่า 10 ฟีเจอร์หลัก' },
    { label: 'ราคา', hotelstack: 'เริ่มต้น $49/เดือน', competitor: 'เริ่มต้น $75+/เดือน' },
    { label: 'คุณภาพ UI/UX', hotelstack: 'ดีไซน์หรูหราสีเข้มทันสมัย', competitor: 'ใช้งานได้ / ล้าสมัย' },
    { label: 'อาหารและเครื่องดื่ม / POS', hotelstack: 'ในตัว', competitor: 'ไม่มี' },
    { label: 'การจัดการรายได้', hotelstack: 'ขั้นสูง (ในตัว)', competitor: 'เครื่องมือราคาพื้นฐาน' },
    { label: 'หลายสาขา', hotelstack: 'จัดการเครือข่ายเต็มรูปแบบ', competitor: 'จำกัด' },
  ],
  featureTable: [
    {
      category: 'ระบบจัดการโรงแรมหลัก',
      features: [
        { name: 'PMS บนคลาวด์', hotelstack: true, competitor: true },
        { name: 'บอร์ดห้องพักแบบภาพ', hotelstack: true, competitor: true },
        { name: 'การจัดการการจอง', hotelstack: true, competitor: true },
        { name: 'วิซาร์ดตรวจสอบกลางคืน', hotelstack: true, competitor: true },
        { name: 'การจัดการโฟลิโอแขก', hotelstack: true, competitor: true },
        { name: 'พอร์ทัลเช็คอินออนไลน์', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'บัญชีและการเงิน',
      features: [
        { name: 'ระบบบัญชีแบบบูรณาการ', hotelstack: true, competitor: true },
        { name: 'งบกำไรขาดทุน', hotelstack: true, competitor: true },
        { name: 'ลูกหนี้', hotelstack: true, competitor: true },
        { name: 'การออกบิลหลายสกุลเงิน', hotelstack: true, competitor: 'จำกัด' },
        { name: 'การปฏิบัติตามกฎหมายภาษีท้องถิ่น', hotelstack: true, competitor: 'เน้น CAD/USD' },
        { name: 'เทมเพลตใบแจ้งหนี้แบบกำหนดเอง', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'รายได้และการจัดจำหน่าย',
      features: [
        { name: 'ตัวจัดการช่องทาง (กว่า 100 OTA)', hotelstack: true, competitor: 'OTA น้อยกว่า' },
        { name: 'กฎการกำหนดราคาไดนามิก', hotelstack: true, competitor: 'พื้นฐาน' },
        { name: 'ตัวจำลองรายได้ What-If', hotelstack: true, competitor: false },
        { name: 'ตัวตรวจสอบราคาคู่แข่ง', hotelstack: true, competitor: false },
        { name: 'การพยากรณ์อุปสงค์', hotelstack: true, competitor: false },
        { name: 'ระบบจองไม่มีค่าคอมมิชชั่น', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'อาหารและเครื่องดื่ม & การดำเนินงาน',
      features: [
        { name: 'เทอร์มินัล POS', hotelstack: true, competitor: false },
        { name: 'โมดูลบริการห้องพัก', hotelstack: true, competitor: false },
        { name: 'ระบบแสดงผลครัว', hotelstack: true, competitor: false },
        { name: 'การจัดการแม่บ้าน', hotelstack: true, competitor: true },
        { name: 'ใบสั่งงานซ่อมบำรุง', hotelstack: true, competitor: false },
        { name: 'การจัดตารางพนักงาน', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'แขกและองค์กร',
      features: [
        { name: 'โปรไฟล์แขก 360 องศา', hotelstack: true, competitor: 'พื้นฐาน' },
        { name: 'การจัดการโปรแกรมสะสมคะแนน', hotelstack: true, competitor: false },
        { name: 'ระบบอัตโนมัติสื่อสารกับแขก', hotelstack: true, competitor: 'จำกัด' },
        { name: 'แดชบอร์ดเครือข่าย', hotelstack: true, competitor: 'จำกัด' },
        { name: 'การวิเคราะห์ข้ามสาขา', hotelstack: true, competitor: false },
        { name: 'การบังคับมาตรฐานแบรนด์', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'ความยืดหยุ่นและออฟไลน์',
      features: [
        { name: 'PWA ที่ใช้งานออฟไลน์ได้', hotelstack: true, competitor: false },
        { name: 'คิวการเปลี่ยนแปลงแบบออฟไลน์', hotelstack: true, competitor: false },
        { name: 'ซิงค์เบื้องหลังเมื่อเชื่อมต่อใหม่', hotelstack: true, competitor: false },
        { name: 'การกระทบยอดที่ตรวจจับความขัดแย้ง', hotelstack: true, competitor: false },
        { name: 'ฟรอนต์เดสก์ที่ติดตั้งได้', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'ฝ่ายขายองค์กรและกรุ๊ป',
      features: [
        { name: 'การจัดการราคาองค์กร', hotelstack: true, competitor: false },
        { name: 'การจองแบบกรุ๊ปพร้อมรายชื่อห้องพัก', hotelstack: true, competitor: false },
        { name: 'รายงานอายุลูกหนี้และผลผลิต', hotelstack: true, competitor: false },
        { name: 'การจองร้านอาหาร', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'พนักงานและทรัพยากรบุคคล',
      features: [
        { name: 'ทำเนียบพนักงานและการจัดตารางเวร', hotelstack: true, competitor: false },
        { name: 'การประมวลผลเงินเดือน', hotelstack: true, competitor: false },
        { name: 'การลาและการลงเวลา', hotelstack: true, competitor: false },
        { name: 'การวิเคราะห์ผลการปฏิบัติงาน', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$75+',
    hotelstackNote: 'รวมทั้ง 36 โมดูล UI ระดับองค์กรทันสมัย ราคาตามภูมิภาคเป็น EUR, GBP, AED, INR, THB เริ่มต้นใช้งานและย้ายข้อมูลฟรี',
    competitorNote: 'ราคาต่อห้องจาก $75+/เดือน CAD อินเทอร์เฟซใช้งานได้แต่ล้าสมัย อาหารและเครื่องดื่มจำกัด หลายสาขาจำกัด สนับสนุนอเมริกาเหนือเป็นหลัก',
  },
  advantages: [
    'โมดูลมากกว่าสามเท่า (36 เทียบกับ 10+) พร้อมอินเทอร์เฟซระดับองค์กรทันสมัย',
    'โมดูลอาหารและเครื่องดื่มสมบูรณ์พร้อม POS บริการห้องพัก และจัดการครัว',
    'จัดการรายได้ขั้นสูงพร้อมราคาไดนามิก การพยากรณ์ และตัวจำลอง What-If',
    'UI หรูหราสีเข้มทันสมัยออกแบบสำหรับปี 2026 เทียบกับอินเทอร์เฟซ WebRezPro ที่ล้าสมัย',
    'จัดการเครือโรงแรมหลายสาขาเต็มรูปแบบพร้อมการวิเคราะห์ส่วนกลางและจัดจำหน่ายราคา',
    'เข้าถึงทั่วโลกกว่า 40 ประเทศ เทียบกับ WebRezPro ที่เน้นอเมริกาเหนือ',
    'โปรแกรมสะสมคะแนน CRM แขก และสื่อสารอัตโนมัติเพื่อเพิ่มการจองซ้ำ',
    'เริ่มต้นใช้งานฟรีและย้ายข้อมูลพร้อมสนับสนุนเฉพาะ 24/7',
  ],
  verdict: {
    title: 'คำตัดสินของเรา',
    summary: 'WebRezPro เป็น PMS จากแคนาดาที่เชื่อถือได้พร้อมฟีเจอร์บัญชีที่แข็งแกร่งสำหรับโรงแรมขนาดเล็กถึงกลางในอเมริกาเหนือ อย่างไรก็ตาม UI ที่ล้าสมัย ฟีเจอร์จำกัด และการขาดอาหารและเครื่องดื่ม เครื่องมือรายได้ขั้นสูง และความสามารถในการขยายระดับองค์กร ทำให้เป็นทางเลือกที่แข่งขันได้น้อยลงในปี 2026 HotelStack.io มอบแพลตฟอร์มทันสมัยครอบคลุมที่เทียบเท่า WebRezPro ด้านบัญชี พร้อมเพิ่มอีกกว่า 22 โมดูล อินเทอร์เฟซระดับโลก และความสามารถทั่วโลก',
    bestFor: [
      'โรงแรมที่ต้องการอัปเกรด UI ทันสมัยโดยไม่สูญเสียความลึกด้านบัญชี',
      'สถานที่ที่ต้องการอาหารและเครื่องดื่ม POS และจัดการครัวเกินกว่า PMS พื้นฐาน',
      'โรงแรมที่ต้องการจัดการรายได้ขั้นสูงและเครื่องมือราคาไดนามิก',
      'สถานที่ที่ขยายสู่ต่างประเทศเกินกว่าอเมริกาเหนือ',
      'กลุ่มโรงแรมที่กำลังเติบโตต้องการจัดการเครือข่ายหลายสาขาเต็มรูปแบบ',
    ],
  },
  faqItems: [
    { question: 'ฉันสามารถย้ายจาก WebRezPro มาที่ HotelStack.io ได้หรือไม่?', answer: 'ได้ ทีมย้ายข้อมูลของเราดำเนินการถ่ายโอนข้อมูลทั้งหมดจาก WebRezPro รวมถึงโปรไฟล์แขก ประวัติการจอง แผนราคา ข้อมูลบัญชี และการตั้งค่าห้อง การย้ายข้อมูลฟรีและมักจะเสร็จภายใน 48 ชั่วโมงโดยไม่หยุดชะงัก' },
    { question: 'HotelStack.io เทียบเท่าความสามารถด้านบัญชีของ WebRezPro หรือไม่?', answer: 'ใช่ HotelStack.io รวมระบบบัญชีแบบบูรณาการ งบกำไรขาดทุน ลูกหนี้ ใบแจ้งหนี้แบบกำหนดเอง และการออกบิลหลายสกุลเงิน นอกจากนี้ยังเพิ่มอีกกว่า 22 โมดูลรวมอาหารและเครื่องดื่ม จัดการรายได้ CRM แขก และจัดการหลายสาขาที่ WebRezPro ไม่มี' },
    { question: 'UI ของ HotelStack.io เปรียบเทียบกับ WebRezPro อย่างไร?', answer: 'HotelStack.io มีอินเทอร์เฟซหรูหราสีเข้มทันสมัยสร้างด้วยเทคโนโลยีเว็บล่าสุด มอบดีไซน์ตอบสนองบนทุกอุปกรณ์ WebRezPro มีอินเทอร์เฟซที่ใช้งานได้แต่ล้าสมัยที่ออกแบบมาสำหรับยุคก่อนหน้าของแอปพลิเคชันเว็บ' },
    { question: 'HotelStack.io เหมาะกับสถานที่ในแคนาดาที่ใช้ WebRezPro อยู่หรือไม่?', answer: 'แน่นอน HotelStack.io รองรับการออกบิลหลายสกุลเงินรวมถึง CAD ปฏิบัติตามกฎหมายภาษีแคนาดา (GST/HST/PST) และเชื่อมต่อกับ OTA หลักในอเมริกาเหนือ สถานที่ในแคนาดาจำนวนมากเปลี่ยนมาเพื่อโมดูลเพิ่มเติมและประสบการณ์ทันสมัย' },
  ],
};


export const COMPARISON_TH_P3B: Record<string, ComparisonConfig> = {
  'hotelstack-vs-innroad': INNROAD_TH,
  'hotelstack-vs-webrezpro': WEBREZPRO_TH,
};
